export default __webpack_public_path__ + "static/media/logo18.4b337013.svg";